// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgLink = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#link_svg__a)">
      <path
        fill={props.color ?? 'currentColor'}
        d="M3.56 12.289a2.507 2.507 0 0 1 0-3.543l1.744-1.743a.768.768 0 0 0-1.086-1.086L2.475 7.66a4.04 4.04 0 0 0 0 5.714 4.04 4.04 0 0 0 5.714 0l1.743-1.742a.768.768 0 1 0-1.085-1.086l-1.743 1.743a2.507 2.507 0 0 1-3.543 0m2.35-2.337a.8.8 0 0 0 1.13 0l3.44-3.44a.8.8 0 0 0 0-1.132l-.01-.012a.8.8 0 0 0-1.132 0l-3.44 3.44a.8.8 0 0 0 0 1.132zm2.28-8.006L6.445 3.688a.768.768 0 1 0 1.086 1.086l1.743-1.743a2.507 2.507 0 0 1 3.543 0 2.507 2.507 0 0 1 0 3.543l-1.743 1.743a.768.768 0 0 0 1.086 1.086l1.743-1.743a4.04 4.04 0 0 0 0-5.714 4.04 4.04 0 0 0-5.715 0"
      />
    </g>
    <defs>
      <clipPath id="link_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgLink
